// This function allow to reference chunks
__webpack_require__.u = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "static/js/async/" + ({"354": "lib-axios","535": "lib-router",}[chunkId] || chunkId) + "." + {"144": "34c416b5","199": "0462d2d5","264": "efc1d37e","282": "a808c4d4","31": "600d0a29","354": "76789bd1","466": "4b3f689d","535": "79300431","625": "1796ed71","640": "dc859832","689": "1c1360ac","787": "d3c925a7","799": "f3d8e058","878": "b774d1d2",}[chunkId] + ".js"
}